import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

// Authentication
import Login from "./auth/login/reducer";
import Account from "./auth/register/reducer";
import ForgetPassword from "./auth/forgetpwd/reducer";
import Profile from "./auth/profile/reducer";

// ecommerce reducers
import businessSettings from "./business-settings/reducer";

// Products
import Products from "./products/reducer";

// Product Categories
import ProductCategories from "./product-categories/reducer";

// Delivery Men
import DeliveryMen from "./delivery-men/reducer";

// Coupons
import Coupons from "./coupons/reducer";

// Discount Types
import DiscountTypes from "./discount-types/reducer";

// Orders
import Orders from "./orders/reducer";

// Disputes
import Disputes from "./disputes/reducer";

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,

  businessSettings,
  Products,
  ProductCategories,
  DeliveryMen,
  Coupons,
  DiscountTypes,
  Orders,
  Disputes,
});

export default rootReducer;
